// src/components/Navbar2.jsx
import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom'; // ✅ Import useLocation
import '../styles/Navbar.css';
import logo from '../Assets/Images/Akij-Insaf-logo.png';
import { FaChevronDown, FaChevronUp, FaEnvelope, FaBars, FaTimes, FaPhoneAlt } from 'react-icons/fa';

function Navbar2() {
  const location = useLocation(); // ✅
  const currentPath = location.pathname.toLowerCase(); // ✅ normalize

  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    {
      title: 'Home',
      path: '/',
    },
    {
      title: 'Our Businesses',
      submenu: [
        { label: 'Akij Textile Mills Ltd.', path: '/akij-textile-mills' },
        { label: 'Akij Bakers Ltd', path: '/akij-bakers' },
        { label: 'Akij Flour Mills Ltd', path: '/akij-flour-mills' },
        { label: 'Akij Printing & Packages Ltd', path: '/akij-printing' },
        { label: 'Lighthouse International School', path: '/lighthouse-international' },
        { label: 'Akij Foundation School, Manikgonj', path: '/akij-foundation' },
        { label: 'Akij Foundation Madrasa', path: '/akij-foundation' },
        { label: 'Al-Madrasatul Munowwaroh', path: '/akij-foundation' },
        { label: 'Monowara Active Technical Institute', path: '/monowara-active-technical' },
        { label: 'Monowara Hospital & Diagonostic Center', path: '/monowara-active-technical' },
        { label: 'WAAW Fashion', path: '/lighthouse-international' },
      ],
    },
    {
      title: 'Contact Us',
      path: '/contact',
    },
  ];

  const isPathActive = (path) => currentPath === path.toLowerCase(); // ✅ match case-insensitive

  return (
    <header className="main-header-home">
      <div className="nav-container-home">
        <Link to="/" className="logo-link-home" onClick={() => setIsMobileMenuOpen(false)}>
          <img src={logo} alt="Akij Insaf Group" className="main-logo-home" />
        </Link>

        <button
          className="hamburger-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav-menu-home ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul>
            {menuItems.map((item, index) => {
              const isParentActive =
                item.path && isPathActive(item.path) ||
                item.submenu?.some((subItem) => isPathActive(subItem.path)); // ✅ parent active if child active

              return (
                <li
                  key={index}
                  className="dropdown-home"
                  onMouseEnter={() => setOpenMenu(index)}
                  onMouseLeave={() => setOpenMenu(null)}
                >
                  {item.path ? (
                    <Link
                      to={item.path}
                      className={`menu-link-home ${isParentActive ? 'active-menu-item-home' : ''}`}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <>
                      <a href="#" className={`menu-link-home ${isParentActive ? 'active-menu-item-home' : ''}`}>
                        {item.title}{' '}
                        {openMenu === index ? (
                          <FaChevronUp className="dropdown-icon-home" />
                        ) : (
                          <FaChevronDown className="dropdown-icon-home" />
                        )}
                      </a>
                      {openMenu === index && (
                        <ul className="dropdown-menu-home">
                          {item.submenu.map((subItem, subIndex) => {
                            const isSubActive = isPathActive(subItem.path);
                            return (
                              <li key={subIndex}>
                                <Link
                                  to={subItem.path}
                                  className={isSubActive ? 'active-menu-item-home' : ''}
                                  onClick={() => setIsMobileMenuOpen(false)}
                                >
                                  {subItem.label}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Contact info + quote (unchanged) */}
        <div className="header-right-section-home">
          <div className="email-block-home">
            <div className="email-label-home">
              <FaPhoneAlt className="email-icon-home" /> Call us at
            </div>
            <a className="email-link-home">
              Our hotline: 01730353735
            </a>
          </div>
          <div className="email-block-home">
            <div className="email-label-home">
              <FaEnvelope className="email-icon-home" /> Email us at
            </div>
            <a href="mailto:info@akijinsaf.com" className="email-link-home">
              info@akijinsaf.com
            </a>
          </div>
          <div className="quote-block-home">
            <div className="quote-frame-home">
              <span className="quote-text-home">" Quality First "</span>
              <div className="quote-author-home">–SK. AKIJ UDDIN</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar2;
